import ForgotPasswordPinView from "./view";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useNavigate } from "react-router-dom";
import {
  sendPinForgot,
  setCustomer,
  validatePinForgot,
} from "@/redux/ducks/customer";

export default function ForgotPasswordPin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const TIME_AGAIN = 1000;

  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [pinAgain, setPinAgain] = useState(false);
  const [error, setError] = useState(false);

  const goBack = () => navigate(-1);

  const goToPassword = () => {
    navigate("/forgot/password");
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    dispatch(
      setCustomer({
        forgot: {
          ...customer?.forgot,
          pin: value,
        },
      }),
    );
  };

  const getIsDisabled = () => {
    if (customer?.forgot?.pin!?.length < 5) return true;
    return false;
  };

  const handleSendPin = () => {
    if (isLoading) return;

    setIsLoading(true);

    dispatch(
      sendPinForgot({
        document: customer?.forgot?.document!,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        callback: (_) => {
          setIsLoading(false);
        },
      }),
    );
  };

  const handleValidatePin = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    dispatch(
      setCustomer({
        forgot: {
          ...customer?.forgot,
          hashCode: errorMessage,
        },
      }),
    );

    goToPassword();
  };

  const handleSubmit = () => {
    if (isLoading || getIsDisabled()) return;

    setIsLoading(true);

    dispatch(
      validatePinForgot({
        document: customer?.forgot?.document!,
        pin: customer?.forgot?.pin!,
        callback: handleValidatePin,
      }),
    );
  };

  const handleTryAgain = () => {
    if (timer !== 0 || isLoading) return;
    setIsLoading(true);
    setTimer(30);
    handleSendPin();
  };

  const updateCount = useCallback(() => {
    if (timer > 0) {
      setTimeout(() => {
        setTimer(timer - 1);
      }, TIME_AGAIN);
    }
  }, [timer]);

  useEffect(() => {
    if (timer !== 0) {
      updateCount();
      if (!pinAgain) setPinAgain(true);
    } else if (pinAgain) setPinAgain(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer, setPinAgain, updateCount]);

  useEffect(() => {
    if (error) setError(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.forgot?.pin]);

  useEffect(() => {
    dispatch(
      setCustomer({
        forgot: {
          ...customer?.forgot,
          pin: "",
        },
      }),
    );
    handleSendPin();
    updateCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ForgotPasswordPinView
      handleTryAgain={handleTryAgain}
      timer={timer}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      pin={customer?.forgot?.pin!}
      onChange={onChange}
      error={error}
      goBack={goBack}
      isDisabled={getIsDisabled()}
    />
  );
}
